import { render, staticRenderFns } from "./deviceTempSensitive.vue?vue&type=template&id=27ef0f9a&scoped=true&"
import script from "./deviceTempSensitive.vue?vue&type=script&lang=js&"
export * from "./deviceTempSensitive.vue?vue&type=script&lang=js&"
import style0 from "./deviceTempSensitive.vue?vue&type=style&index=0&id=27ef0f9a&lang=scss&scoped=true&"
import style1 from "./deviceTempSensitive.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ef0f9a",
  null
  
)

export default component.exports